import { Faq } from 'fitify-ui-onboarding/src/components/Paywall/Faq/Faq'
import { Segment } from 'fitify-ui-onboarding/src/components/Paywall/Segment/Segment'
import { useFeatureIsOn } from 'fitify-ui-onboarding/src/utils/growthbook/generated'
import { useTranslation } from 'next-i18next/pages'
import { useMemo, useState } from 'react'

import { useFunnel } from 'hooks/useFunnel'
import { StyledPaywallFaqContainer } from 'sections/subscription/PaywallFaq.Styled'
import {
  getFunnelFaqItem,
  getGoalFaqItem,
} from 'sections/subscription/PaywallFaq.Utils'
import { useDataState } from 'utils/state'

export const PaywallFaq = () => {
  const { t } = useTranslation()
  const isEnabled = useFeatureIsOn('paywall_faq_enabled')
  const funnel = useFunnel()
  const { data } = useDataState()
  const [openIndex, setOpenIndex] = useState<number | undefined>(0)

  const goal = funnel ? data[funnel].goal : undefined
  const gender = data[funnel || 'shared'].gender

  const items = useMemo(
    () => [
      getGoalFaqItem({ funnel, gender, goal, t }),
      getFunnelFaqItem({ funnel, t }),
      {
        question: t('paywall_faq_access_question'),
        answer: t('paywall_faq_access_answer'),
      },
    ],
    [funnel, gender, goal, t]
  )

  if (!isEnabled) {
    return null
  }

  return (
    <Segment title={t('paywall_faq_title')}>
      <StyledPaywallFaqContainer>
        {items.map((item, index) => (
          <Faq
            key={item.question}
            answer={item.answer}
            isOpen={openIndex === index}
            onToggle={() =>
              setOpenIndex((current) => (current === index ? undefined : index))
            }
            question={item.question}
          />
        ))}
      </StyledPaywallFaqContainer>
    </Segment>
  )
}
